﻿/* 
   SESSION TIMEOUT MODAL — FINAL LM VERSION

   Features:
   - CMS driven timeout values
   - Warning popup before timeout
   - Reverse countdown
   - Multi-tab sync
   - Popup stays open until explicit action
   - Outside clicks do NOT close popup
   - Stay Logged In syncs across tabs
   - Logout syncs across tabs
   - Internal sites completely skip timeout logic
 */

(function () {

    "use strict";

    /* SKIP SESSION TIMEOUT FOR INTERNAL SITES */

    if (window.sessionTimeoutConfig?.isInternalSite) {
        return;
    }


    /* CONFIG (FROM _Scripts.cshtml) */

    const SESSION_TIMEOUT = (window.sessionTimeoutConfig?.sessionTimeoutMinutes || 60) * 60;

    const WARNING_TIME = (window.sessionTimeoutConfig?.warningPopupMinutes || 15) * 60;

    /*STORAGE KEYS */

    const STORAGE_KEYS = {
        ACTIVITY: "session_last_activity",
        LOGOUT: "session_logout_event"
    };

    /*DOM ELEMENTS */

    const modal = document.getElementById("session-timeout-modal");

    const countdown = document.getElementById("timeout-countdown");

    const stayBtn = document.getElementById("stay-logged-in");

    const logoutBtn = document.getElementById("logout-now");

    const logoutUrl = "/auth/logout";

    if (!window.isAuthenticated || !modal || !countdown) {
        return;
    }

    /*STATE*/

    let modalVisible = false;
    let countdownInterval = null;

    /*HELPERS*/

    function now() {
        return Math.floor(Date.now() / 1000);
    }

    function getLastActivity() {

        return parseInt(localStorage.getItem(STORAGE_KEYS.ACTIVITY), 10) || now();
    }

    function setLastActivity() {

        localStorage.setItem(STORAGE_KEYS.ACTIVITY, now());
    }

    function formatTime(seconds) {

        const minutes = Math.floor(seconds / 60);

        const remainingSeconds = seconds % 60;

        return (
            String(minutes).padStart(2, "0") +
            ":" +
            String(remainingSeconds).padStart(2, "0")
        );
    }

    /*MODAL CONTROL*/

    function showModal() {

        if (modalVisible) {
            return;
        }

        modalVisible = true;

        modal.classList.add("show");

        startCountdown();
    }

    function hideModal() {

        modalVisible = false;

        modal.classList.remove("show");

        if (countdownInterval) {

            clearInterval(countdownInterval);

            countdownInterval = null;
        }
    }

    /*COUNTDOWN*/

    function startCountdown() {
        updateCountdown();

        countdownInterval = setInterval(updateCountdown, 1000);
    }

    function updateCountdown() {

        const elapsed = now() - getLastActivity();

        const remaining = SESSION_TIMEOUT - elapsed;

        countdown.textContent =
            formatTime(Math.max(0, remaining));

        if (remaining <= 0) {

            logout();
        }
    }

    /*LOGOUT*/

    function logout() {

        localStorage.setItem(STORAGE_KEYS.LOGOUT, now());
        window.location.href = logoutUrl;
    }

    /*USER ACTIVITY
       IMPORTANT:
       Ignore ALL activity while popup visible.
     */

    function activityHandler(event) {

        if (modalVisible) {
            return;
        }

        const target = event.target;

        if (!(target instanceof Element)) {
            return;
        }

        if (target.closest("#session-timeout-modal")) {
            return;
        }

        setLastActivity();
    }

    /*BLOCK OUTSIDE CLICK WHILE MODAL OPEN

       IMPORTANT:
       Prevent LM/global delegated modal
       handlers from closing popup.
     */

    document.addEventListener("click", function (event) {

        if (!modalVisible) {
            return;
        }

        const target = event.target;

        if (
            target &&
            typeof target.closest === "function" &&
            target.closest(".lm__information-modal")
        ) {
            return;
        }

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

    }, true);

    /* REGISTER ACTIVITY EVENTS */

    [
        "mousemove",
        "mousedown",
        "keydown",
        "scroll",
        "touchstart",
        "click"
    ].forEach(function (eventName) {

        document.addEventListener(eventName, activityHandler, true);
    });

    /* BUTTON EVENTS */

    stayBtn?.addEventListener("click", function () {

        /* Explicit session refresh action */
        setLastActivity();
        hideModal();
    });

    logoutBtn?.addEventListener("click", function () {
        logout();
    });

    /* MULTI TAB SYNC */

    window.addEventListener("storage", function (event) {

        /*
           ONLY close popup if another tab
           intentionally refreshed session.
        */
        if (
            event.key === STORAGE_KEYS.ACTIVITY && modalVisible
        ) {

            const elapsedSinceRefresh = now() - getLastActivity();

            /* Recently refreshed = Stay Logged In clicked in another tab.
            */
            if (elapsedSinceRefresh <= 2) {

                hideModal();
            }
        }

        /* Logout sync across all tabs */
        if (
            event.key === STORAGE_KEYS.LOGOUT
        ) {

            window.location.href = logoutUrl;
        }
    });

    /* INITIALIZE*/

    setLastActivity();

    /* MAIN TIMER LOOP */
    setInterval(function () {

        const elapsed = now() - getLastActivity();

        const warningTrigger = SESSION_TIMEOUT - WARNING_TIME;

        /* Show warning popup */
        if (
            !modalVisible && elapsed >= warningTrigger
        ) {

            showModal();
        }

        /* Hard logout */
        if (elapsed >= SESSION_TIMEOUT) {

            logout();
        }

    }, 1000);

})();